import React, { memo } from "react";

import { useFormContext } from "react-hook-form";

import { Text } from "@origin-digital/ods-core";
import { task } from "@origin-digital/reporting-client";

import { RouterActions, StyledHeading, TextInput } from "@/components";
import { StyledQuestion } from "@/components/StyledQuestion";
import { ANALYTICS_FORM_NAME, ANALYTICS_TASK_TYPE } from "@/constants";
import { useFieldValidation } from "@/hooks";

import { customerContact } from "./content.json";

export const CustomerContact = memo(
  ({
    backRoute,
    nextRoute,
  }: {
    backRoute: () => Promise<string>;
    nextRoute: () => Promise<string>;
  }) => {
    const { register, getValues } = useFormContext();
    const { isValid } = useFieldValidation({
      fields: ["contactNumber"],
    });

    const trackFormUpdate = async () => {
      const contactNumber = getValues("contactNumber");
      if (await isValid()) {
        task.base(ANALYTICS_TASK_TYPE, {
          action: "update",
          formName: ANALYTICS_FORM_NAME,
          customer: {
            contactNumber,
          },
        });
        return true;
      }
      return false;
    };

    return (
      <StyledQuestion>
        <div>
          <StyledHeading>{customerContact.heading}</StyledHeading>
          <Text wordBreak={true}>{customerContact.description}</Text>
          <br />
          <TextInput
            id={customerContact.contactNumber.id}
            data-id={customerContact.contactNumber.id}
            label={customerContact.contactNumber.label}
            {...register("contactNumber")}
          />
        </div>

        <RouterActions
          onBackRoute={backRoute}
          onNextRoute={nextRoute}
          onNext={trackFormUpdate}
        />
      </StyledQuestion>
    );
  }
);
